export default "__VITE_ASSET__d0e315b8__"